import { useQuery } from '@tanstack/react-query';

import { listCampaigns } from '../../api';

/**
 * Campaign names already in the library, for the campaign input's datalist.
 *
 * Campaign name is free text by design — the agencies name campaigns, not this
 * app — and a datalist is what keeps free text from fragmenting: the uploader
 * sees "Puma Gen-E Launch" before typing "puma gen e launch". Suggestions, not
 * a vocabulary: anything typed is accepted.
 *
 * Cached for a few minutes because the list only changes when someone types a
 * new campaign; without it, it would refetch on every mount of the form and
 * every window focus.
 */
export function useCampaignSuggestions(enabled = true): string[] {
  const { data } = useQuery({
    queryKey: ['asset-library', 'campaigns'],
    queryFn: listCampaigns,
    staleTime: 5 * 60 * 1000,
    enabled,
  });
  return data?.campaigns ?? [];
}
